import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { sortExchangeAmounts } from "../ExchangeAmount/utils";
export const useExchangeStyles = makeStyles({
    xs: {
        fontSize: ".6rem",
        lineHeight: 1.1,
    },
    padding: {
        padding: "4px",
    },
});
export const ExchangeSummaryLabel = ({ targetExchangeAmounts, variant, consolidatePro, hideZeros, intralabelPadding = false, }) => {
    const classes = useExchangeStyles();
    const firstProTgt = targetExchangeAmounts.find(et => et.exchange.type === "protein");
    const consolidatedExchangeTargets = consolidatePro && firstProTgt
        ? [
            ...targetExchangeAmounts.filter(et => et.exchange.type !== "protein"),
            targetExchangeAmounts
                .filter(et => et.exchange.type === "protein" && et.id !== firstProTgt.id)
                .reduce((a, b) => ({ ...a, amount: a.amount + b.amount }), {
                ...firstProTgt,
                exchange: { ...firstProTgt.exchange, shortName: "Pro" },
            }),
        ]
        : targetExchangeAmounts;
    const sortedExchangeTargets = sortExchangeAmounts(consolidatedExchangeTargets);
    const finalExchangeTargets = sortedExchangeTargets.filter(et => !hideZeros || et.amount > 0);
    return (_jsx(Typography, { variant: variant === "lg" ? "subtitle1" : "caption", classes: variant === "xs" ? { root: classes.xs } : {}, color: "inherit", children: finalExchangeTargets.map(et => (_jsxs("span", { className: intralabelPadding ? classes.padding : undefined, children: [_jsx("span", { children: et.exchange.shortName }), ": ", et.amount, " "] }, et.id))) }));
};
//# sourceMappingURL=SummaryLabel.js.map